module.exports = __webpack_public_path__ + "img/produce_fruit_only-min.500ce024.png";